import { createTheme, createStyles } from '@material-ui/core/styles';
const styles = (theme) => createStyles({
    root: {
        flex: '1',
    },
    rootCollapsed: {
        flex: 'unset',
    },
    headerCollapsed: {
        borderRadius: 5,
    },
    tableCell: {
        top: 0,
        position: 'sticky',
        background: theme.color.background.light,
        color: theme.color.font.dark,
        fontSize: theme.font.size.mediumBig,
        fontWeight: theme.font.weight.bold,
        boxShadow: `inset 0 -2px 0 ${theme.color.font.dark}`,
        padding: 5,
    },
    tableCellAction: {
        position: 'sticky',
        right: 0,
        background: theme.color.background.light,
        zIndex: 101,
        backgroundClip: 'padding-box',
        padding: 5,
    },
    tableHeaderActionCell: {
        zIndex: 102,
        right: 0,
        whiteSpace: 'nowrap',
        borderBottom: 'none',
    },
    tableHeaderCell: {
        zIndex: 100,
        left: 0,
        whiteSpace: 'nowrap',
        borderBottom: 'none',
    },
    panelContent: {
        padding: 0,
        position: 'relative',
        flex: '1',
    },
    tableFooter: {
        position: 'relative',
        maxHeight: 300,
        minHeight: 80,
        background: theme.color.background.light,
    },
    checkbox: {
        marginRight: 0,
    },
});
export const tableOverrideTheme = createTheme({
    overrides: {
        MUIDataTable: {
            responsiveScrollMaxHeight: {
                maxHeight: 'none',
                position: 'absolute !important',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
            },
        },
        MuiTableCell: {
            root: {
                padding: 5,
            },
        },
    },
});
export default styles;
//# sourceMappingURL=DataTableStyles.js.map